module.exports = __webpack_public_path__ + "img/free.11179677.svg";